import { render } from "./EditGroupModal.vue?vue&type=template&id=385a1e30&scoped=true"
import script from "./EditGroupModal.vue?vue&type=script&lang=js"
export * from "./EditGroupModal.vue?vue&type=script&lang=js"

import "./EditGroupModal.vue?vue&type=style&index=0&id=385a1e30&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-385a1e30"]])

export default __exports__